export interface QuippyAssistantCopy {
    readonly inputPlaceholder: string;
    readonly subtitle: string;
}

export const BUILDING_ASSISTANT_COPY: QuippyAssistantCopy = {
    inputPlaceholder: 'Ask Quippy anything about your building...',
    subtitle: 'Your intelligent building assistant',
};

export const PORTFOLIO_ASSISTANT_COPY: QuippyAssistantCopy = {
    inputPlaceholder: 'Ask Quippy anything about your portfolio...',
    subtitle: 'Your intelligent portfolio assistant',
};

export function getQuippyAssistantCopy(
    kind: 'building' | 'portfolio'
): QuippyAssistantCopy {
    return kind === 'portfolio'
        ? PORTFOLIO_ASSISTANT_COPY
        : BUILDING_ASSISTANT_COPY;
}
